import { CheckCircle } from "lucide-react";
import {
  Container,
  AnimationContainer,
  OuterGear,
  Content,
  InnerGear,
  CenterIcon,
  BouncingIcon,
  StatusText,
  Title,
  Subtitle,
} from "./style";
import Gear from "./components/gear";
const PaymentSuccess = () => {
  return (
    <Container>
      <Content>
        <AnimationContainer>
          <OuterGear loading={false}>
            <Gear teeth={12} radius={80} color={"#1B9742"} />
          </OuterGear>
          <InnerGear loading={false}>
            <Gear teeth={12} radius={60} color={"#1B9742"} />
          </InnerGear>
          <CenterIcon loading={false}>
            <BouncingIcon>
              <CheckCircle size={64} color="#1B9742" />
            </BouncingIcon>
          </CenterIcon>
        </AnimationContainer>
        <StatusText>
          <>
            <Title color="#1B9742">Payment Successful!</Title>
            <Subtitle color="#1B9742">
              Your transaction has been completed
            </Subtitle>
          </>
        </StatusText>
      </Content>
    </Container>
  );
};

export default PaymentSuccess;
